import { render, staticRenderFns } from "./AddGuardianDialog.vue?vue&type=template&id=29822a1a&scoped=true"
import script from "@/views/Users/Student/Dialogs/AddGuardianDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Dialogs/AddGuardianDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Dialogs/add-guardian-dialog.scss?vue&type=style&index=0&id=29822a1a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29822a1a",
  null
  
)

export default component.exports